import { useState } from "react";
import {
  Grid,
  TextField,
  DataGrid,
  Button,
  Autocomplete,
} from "../../../../../components";
import { responseErros, formatCnpj, formatPrice } from "../../../../../utils";
import {
  MdfeLacresService,
  MdfePedagioService,
  MdfeService,
  notification,
} from "../../../../../services";
import shortid from "shortid";
import { PedagioDialog } from "../";
import { value } from "../../../../../helpers";

const mdfeLacresService = new MdfeLacresService();
const mdfePedagioService = new MdfePedagioService();
const mdfeService = new MdfeService();

export default function TabControleRodoviario({
  id,
  setLoading,
  status,
  nfsSaida,
  lacres,
  setLacres,
  pedagios,
  setPedagios,
}) {
  const [lacre, setLacre] = useState();
  const [documentoFiscalEletronico, setDocumentoFiscalEletronico] = useState();
  const [erroLacreNumero, setErroLacreNumero] = useState(false);
  const [openDialogoPedagio, setOpenDialogoPedagio] = useState(false);
  const lacresColunas = [
    {
      field: "numero",
      headerName: "Lacre",
      flex: 100,
    },
    {
      field: "chaveDfe",
      headerName: "Chave DF-e",
      flex: 200,
    },
  ];
  const pedagioColunas = [
    {
      field: "cnpjFornecedora",
      headerName: "CNPJ Fornecedor",
      flex: 200,
      valueGetter: (params) => formatCnpj(params.value),
    },
    {
      field: "cnpjPagador",
      headerName: "CNPJ Pagador",
      valueGetter: (params) => formatCnpj(params.value),
      flex: 200,
    },
    {
      field: "comprovante",
      headerName: "Comprovante",
      flex: 150,
    },
    {
      field: "valor",
      headerName: "Valor",
      valueGetter: (params) => formatPrice(params.value),
      flex: 150,
    },
  ];

  const handleInputChangeLacre = (event) => {
    const { value } = event.target;
    setLacre(value);
  };

  const onClickAdicionarLacre = () => {
    if (!lacre) {
      setErroLacreNumero(true);
      return notification.erroValidacao("Número Lacre");
    }
    let chaveDfe = null;
    if (documentoFiscalEletronico) {
      chaveDfe = documentoFiscalEletronico?.chaveDfe;
    }
    const lacreAdicao = {
      id: shortid.generate(),
      numero: lacre,
      chaveDfe,
      fatMdfeId: id,
    };
    if (id) {
      cadastrarLacre(lacreAdicao);
    } else {
      setLacres([...lacres, lacreAdicao]);
    }
    setLacre();
    setDocumentoFiscalEletronico();
    setErroLacreNumero(false);
  };

  async function cadastrarLacre(lacreAdicao) {
    setLoading(true);
    const response = await mdfeService.cadastrarLacre(id, lacreAdicao);
    if (!response.isAxiosError) {
      await buscarLacres();
      setLoading(false);
      notification.cadastroSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  async function buscarLacres() {
    const filter = {
      fatMdfeId: id,
      nonPaginated: true,
    };
    const response = await mdfeLacresService.getAll(filter);
    if (!response.isAxiosError) {
      setLacres(response.data);
    } else {
      responseErros(response);
    }
  }

  async function deletarLacre(idLacre) {
    setLoading(true);
    const response = await mdfeLacresService.deletar(idLacre);
    if (!response.isAxiosError) {
      await buscarLacres();
      setLoading(false);
      notification.deletadoSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  const onclickDeletarLacre = (idLacre) => {
    if (id) {
      deletarLacre(idLacre);
    } else {
      setLacres(lacres.filter((lacre) => lacre.id != idLacre));
    }
  };

  async function cadastrarPedagio(pedagioAdicao) {
    setLoading(true);
    const response = await mdfeService.cadastrarPedagio(id, pedagioAdicao);
    if (!response.isAxiosError) {
      await buscarPedagios();
      setLoading(false);
      notification.cadastroSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  async function buscarPedagios() {
    const filter = {
      fatMdfeId: id,
      nonPaginated: true,
    };
    const response = await mdfePedagioService.getAll(filter);
    if (!response.isAxiosError) {
      setPedagios(response.data);
    } else {
      responseErros(response);
    }
  }

  async function deletarPedagio(idPedagio) {
    setLoading(true);
    const response = await mdfePedagioService.deletar(idPedagio);
    if (!response.isAxiosError) {
      await buscarPedagios();
      setLoading(false);
      notification.deletadoSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  const onclickDeletarPedagio = (idPedagio) => {
    if (id) {
      deletarPedagio(idPedagio);
    } else {
      setPedagios(pedagios.filter((pedagio) => pedagio.id != idPedagio));
    }
  };

  const handleClickOpenDialogoPedagio = () => {
    setOpenDialogoPedagio(true);
  };

  const onChangeAutocompleteDfe = (value) => {
    setDocumentoFiscalEletronico(value);
  };

  return (
    <Grid container>
      <Grid container xs={5} spacing={2} className="mt-1">
        <Grid item xs={5}>
          <TextField
            id="numero"
            name="numero"
            label="Numero Lacre"
            error={erroLacreNumero}
            type="text"
            onChange={handleInputChangeLacre}
            fullWidth
            value={value.text(lacre)}
            disabled={status != "PENDENTE"}
          />
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            id="documentoFiscalEletronico"
            name="documentoFiscalEletronico"
            options={nfsSaida}
            autoHighlight
            disabled={!nfsSaida?.length}
            getOptionLabel={(option) => option.codigoNfSaida || option.chaveDfe}
            renderInput={(params) => (
              <TextField {...params} label="Documento Fiscal Eletronico" />
            )}
            onChange={(_, newValue) => onChangeAutocompleteDfe(newValue)}
            value={documentoFiscalEletronico}
          />
        </Grid>
        <Grid item xs={1} className="mt-2">
          <Button
            id="buttonAdicionarLacre"
            variant="contained"
            color="success"
            size="small"
            disabled={status != "PENDENTE"}
            sx={{
              height: "35px",
              borderRadius: "50%",
              minWidth: "15px",
              boxShadow: "none",
            }}
            onClick={onClickAdicionarLacre}
          >
            <i
              className="ph-bold ph-plus"
              style={{ color: "#fff", fontSize: 15 }}
            ></i>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            style={{ zIndex: 1 }}
            rows={lacres}
            columns={lacresColunas}
            rowCount={lacres.length}
            onClickDelete={onclickDeletarLacre}
            deleteShow={status != "PENDENTE" ? false : true}
          />
        </Grid>
      </Grid>
      <Grid
        container
        xs={1}
        fullWidth
        className="d-flex justify-content-center"
      >
        <hr className="vr" />
      </Grid>
      <Grid container xs={6} spacing={2} className="mt-2">
        <Grid item xs={12}>
          <Button
            onClick={() => handleClickOpenDialogoPedagio()}
            color="primary"
            variant="contained"
          >
            <i
              className="ph-fill ph-plus-circle"
              style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
            ></i>{" "}
            Adicionar Pedagio
          </Button>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            style={{ zIndex: 1 }}
            rows={pedagios}
            columns={pedagioColunas}
            rowCount={pedagios.length}
            onClickDelete={onclickDeletarPedagio}
            deleteShow={status != "PENDENTE" ? false : true}
          />
        </Grid>
      </Grid>
      <PedagioDialog
        open={openDialogoPedagio}
        setOpen={setOpenDialogoPedagio}
        setPedagios={setPedagios}
        pedagios={pedagios}
        id={id}
        cadastrarPedagio={cadastrarPedagio}
      />
    </Grid>
  );
}
